module.exports = __webpack_public_path__ + "img/bj.18a4a4de.png";